import type { CalibrationEmployee, CalibrationReport } from '@/types/calibration';

/** Every evaluated employee of the report, flattened out of their manager rows. */
export const flattenEmployees = (report: CalibrationReport): CalibrationEmployee[] =>
    report.managers.flatMap((manager) => manager.employees);

/** Employees whose calibration is still a draft — the rows a publication would push out. */
export const countDraftAdjustments = (report: CalibrationReport): number =>
    flattenEmployees(report).filter((employee) => employee.adjustment?.status === 'Draft').length;
